/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/041-file-music': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"/><path pid="1" d="M11.817 6.113a.501.501 0 00-.415-.104l-5 1a.5.5 0 00-.402.49V11.2a2.514 2.514 0 00-1-.201c-1.105 0-2 .672-2 1.5s.895 1.5 2 1.5 2-.672 2-1.5v-3.59l4-.8V10.2a2.514 2.514 0 00-1-.201c-1.105 0-2 .672-2 1.5s.895 1.5 2 1.5 2-.672 2-1.5v-5a.5.5 0 00-.183-.387z"/>'
  }
})
